import type Sections from "../../../../../enums/sections";
import { type RolePermissions, type UsersGroupsContext } from "../../../../../enums";

interface PeopleOverview {
  section: Sections;
  isReadOnly: boolean;
  customHeaderContent: React.ReactElement;
  assignedPeopleIds: number[];
}

export interface PeopleWrapperProps {
  permission: RolePermissions;
  onContextChanged?: (context: UsersGroupsContext) => void;
  usersGroupsContext?: UsersGroupsContext;
  renderUsersOverview: (customHeaderContent: React.ReactElement, isReadOnly: boolean) => React.ReactElement;
  renderGroupsOverview: (customHeaderContent: React.ReactElement, isReadOnly: boolean) => React.ReactElement;
  renderTemplateGroupsOverview?: (customHeaderContent: React.ReactElement, isReadOnly: boolean) => React.ReactElement;
}

export interface GroupsOverviewProps extends PeopleOverview {}

export interface TemplateGroupsOverviewProps extends PeopleOverview {
  onlyOwn?: boolean;
  customHeaderContent: React.ReactElement;
  isReadOnly: boolean;
}

export interface UsersOverviewProps extends PeopleOverview {}

export interface TemplateOverview {
  name: string;
  id: number;
  publisher: string;
  dateCreated: string;
  dateModified: string;
}

export enum TemplatesFiltersEnum {
  DateCreated = "dateCreated",
}
